import { useContext } from "react";
import { useQuery } from "react-query";
import { AxiosContext } from "services/axios.context";

export const useTerritories = () => {
  const { client } = useContext(AxiosContext);
  return useQuery(`territories`, () => {
    console.debug(`territories retrieved`);
    return client.get(`enums/territories/`).then((resp) => resp.data);
  });
};
